import { useSelector } from "react-redux";
import Table from "../table/Table";
import { StoreState } from "../../../../redux/storeState/storeState";

interface StoreDetailsIProp {
  setSelectedOption: any;
  headerData: any;
  tableData: any;
  page: number;
  size: number;
  setpage: any;
  setsize: any;
  total: number;
  handleSearch: any;
  handleSortClick: any;
  handleSort: any;
  searchText: any;
  selectedHeader: any;
  setSearchText: any;
  resetHandler: any;
}
function IntegrationDetails({
  setSelectedOption,
  page,
  setpage,
  setsize,
  size,
  total,
  handleSort,
  handleSortClick,
  tableData,
  headerData,
  searchText,
  selectedHeader,
  setSearchText,
  resetHandler,
  handleSearch,
}: StoreDetailsIProp) {
  const { companyInfo } = useSelector((state: StoreState) => ({
    companyInfo: state.companies.companySideInfoData,
  }));
  return (
    <div>
      <div className="main-overview-wrap">
        <div className="title-subscription">Companies &gt; {companyInfo?.businessName} &gt; Integration</div>
        <button
          className="back-btn"
          onClick={() => {
            window.history.back();
          }}
        >
          Back
        </button>
      </div>
      {/* <div className="subscription-id">Business ID {companyInfo?.businessId}</div> */}
      <div className="mt-3">
        <Table
          setSelectedOption={setSelectedOption}
          tableHeadData={headerData}
          tableBodyData={tableData}
          page={1}
          size={10}
          setPage={() => {}}
          setSize={() => {}}
          total={1}
          handleSiteSearch={handleSearch}
          handleArrowSortClick={handleSortClick}
          handleSort={handleSort}
          searchText={searchText}
          selectedSiteHeader={selectedHeader}
          setsiteSearchText={setSearchText}
          subscriptionView={false}
          placeholder="Search integration"
          singleDetailPath="integration_pos_details"
          resetHandler={resetHandler}
        />
      </div>
    </div>
  );
}

export default IntegrationDetails;
